/**
 * /comms/channels — critical route (loader/guard shell). The component is
 * code-split into ./channels.lazy. Behind VITE_COMM_CENTER; the route tree is
 * wired in Wave 2 (routeTree regen), so this typechecks after regeneration.
 * Agent U2.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/comms/channels')({});
